<script>
import FormModel from "@/views/Absence/AbsenceRequest/Components/FormModel.vue";

export default {
    name: "HolidayForm",
    components: {FormModel},
    props: {
        addAction: Boolean,
        deleteAction: Boolean,
        updateAction: Boolean,
        viewAction: Boolean,
    },
}
</script>

<template>
    <FormModel
        :add-action="addAction"
        :update-action="updateAction"
        :delete-action="deleteAction"
        :view-action="viewAction"
        vacation
    />
</template>